import styled from '@emotion/styled'

export default styled.span`
  background: -webkit-linear-gradient(#265f78, #28b8e3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`
